import { render, staticRenderFns } from "./omsetjeniskiriman_chart.vue?vue&type=template&id=497f8d06"
import script from "./omsetjeniskiriman_chart.vue?vue&type=script&lang=js"
export * from "./omsetjeniskiriman_chart.vue?vue&type=script&lang=js"
import style0 from "./omsetjeniskiriman_chart.vue?vue&type=style&index=0&id=497f8d06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports